import React from 'react';
import PropTypes from 'prop-types';

import LeaseInformation from './sections/lease-information';
import TenantInformation from './sections/tenant-information';
import LandlordInformation from './sections/landlord-information';
import { getVoucherAccordionStorageKey } from '../file-upload-accordian';

const LeaseDetails = ({
  dealId,
  forceLandlordInformationExpanded,
  forceLeaseInformationExpanded,
  forceTenantInformationExpanded,
  isLandlordInformationLoaded,
  isLeaseInformationLoaded,
  isTenantInformationLoaded,
  onLandlordInformationExpand,
  onLeaseInformationExpand,
  onTenantInformationExpand,
  propertyOptions,
}) => (
  <>
    <LeaseInformation
      forceExpanded={forceLeaseInformationExpanded}
      isLoaded={isLeaseInformationLoaded}
      onExpand={onLeaseInformationExpand}
      propertyOptions={propertyOptions}
      storageKey={getVoucherAccordionStorageKey(dealId, 'leaseDetails', 'leaseInformation')}
    />
    <TenantInformation
      forceExpanded={forceTenantInformationExpanded}
      isLoaded={isTenantInformationLoaded}
      onExpand={onTenantInformationExpand}
      storageKey={getVoucherAccordionStorageKey(dealId, 'leaseDetails', 'tenantInformation')}
    />
    <LandlordInformation
      forceExpanded={forceLandlordInformationExpanded}
      isLoaded={isLandlordInformationLoaded}
      onExpand={onLandlordInformationExpand}
      storageKey={getVoucherAccordionStorageKey(dealId, 'leaseDetails', 'landlordInformation')}
    />
  </>
);

LeaseDetails.propTypes = {
  dealId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  forceLandlordInformationExpanded: PropTypes.bool,
  forceLeaseInformationExpanded: PropTypes.bool,
  forceTenantInformationExpanded: PropTypes.bool,
  isLandlordInformationLoaded: PropTypes.bool,
  isLeaseInformationLoaded: PropTypes.bool,
  isTenantInformationLoaded: PropTypes.bool,
  onLandlordInformationExpand: PropTypes.func,
  onLeaseInformationExpand: PropTypes.func,
  onTenantInformationExpand: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  propertyOptions: PropTypes.arrayOf(PropTypes.shape({
    display_name: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
  })),
};

LeaseDetails.defaultProps = {
  dealId: '',
  forceLandlordInformationExpanded: false,
  forceLeaseInformationExpanded: false,
  forceTenantInformationExpanded: false,
  isLandlordInformationLoaded: false,
  isLeaseInformationLoaded: false,
  isTenantInformationLoaded: false,
  onLandlordInformationExpand: () => {},
  onLeaseInformationExpand: () => {},
  onTenantInformationExpand: () => {},
  propertyOptions: [
    { display_name: 'None', value: null },
  ],
};

export default LeaseDetails;
